<template>

  <div id='' class='gPageBorder' v-loading=loading>

      <tyc :tqobj='tqobj' ></tyc>
      <!-- <el-row v-for='item in gBase'>
        <el-col :span='4' v-for='sub in gSub'>
          <pre>{{sub}}{{item}}</pre>
        </el-col>
      </el-row> -->

      <el-row>
        <!-- <el-col :span='4'>
          <div class='gSgLeftBtn'>
            <MechanismSelector :data="mechanismData"></MechanismSelector>
          </div>
        </el-col> -->

        <el-col :span='4'>
          
          <div class='gLeftScCtrl'>
            <el-select v-model="taskType"  :placeholder="$t('app_taskType')" clearable @change="query">
              <el-option
                v-for="item in missionList"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span='4'>
          <div class='gLeftScCtrl'>
            <el-input :placeholder="$t('app_taskName')"
                      @keyup.enter.native='query'
                      v-model='missionName'
                      icon="search"
                      :on-icon-click="query">
            </el-input>
          </div>
         
        </el-col>
      </el-row>



    <div id='cmData'>
      <el-table
        class='gTopMg tbPoint'
        @row-click='cellClick'
        :data="tableData"
        border
        style="width: 100%">

        <el-table-column
          header-align='center'
          align='center'
          prop="fileName"
          :label="$t('app_taskDetail')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          :label="$t('app_version')"
          width="">
        </el-table-column>


        <el-table-column
          header-align='center'
          align='left'
          :label="$t('app_taskType')"
          width="">
          <template slot-scope="scope">
            <label>{{missionNames[scope.row.taskType]}}</label>
          </template>
        </el-table-column>

        <!-- <el-table-column
          header-align='center'
          align='left'
          prop="mechanismName"
          :label="$t('app_distributor')"
          width="">
        </el-table-column> -->

        <el-table-column
          header-align='center'
          align='center'
          prop="terNums"
          :label="$t('app_deviceNum')"
          width="95">
        </el-table-column>

        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="waitingNums"
          :label="$t('app_waiting')"
          width="80">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="goingNums"
          :label="$t('app_downloading')"
          width="80">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="failNums"
          :label="$t('app_fail')"
          width="80">
        </el-table-column>

     

        <el-table-column
          header-align='center'
          align='center'
          prop="cancelNums"
          :label="$t('app_cancel')"
          width="80">
        </el-table-column> -->

        <el-table-column
          header-align='center'
          align='center'
          prop="createTime"
          :label="$t('app_pushTime')"
          width="170">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          :label="$t('app_operate')"
          width="">
            <template slot-scope='scope'>
              <!-- <el-button type='text'>{{$t('lin_global.look_detail')}}</el-button> -->

              <!-- <el-tooltip class="item" effect="dark" :content="$t('app_cancelPush')" placement="top">
                <el-button type='text' @click='cancelPush(scope.row)'><i class="fa fa-window-close" style="color:#FF4949"></i></el-button>
              </el-tooltip> -->

              <el-tooltip class="item" effect="dark" :content="$t('lin_global.look_detail')" placement="top">
                <el-button type='text' @click='viewDetail(scope.row)'><i class="fa fa-file-text" style=""></i></el-button>
              </el-tooltip>

            </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="" v-model="dialogFormVisible" @open=open @close='close'>
      <div>
        <table style='width:100%;'>
          <tr>
            <td style='width:25%;text-align:center;'>{{$t('app_typeName')}}：</td>
            <td><el-input style='' v-model='name'></el-input></td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure">{{$t('app_sure')}}</el-button>
      </div>
    </el-dialog>

    <div class="gPgDiv">

      <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>

  </div>
</template>

<style>
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import TemplateName from "../global/mechanism_selector.vue";
  import tyc from '@/components/global/tyc.vue'
  export default{
    components: {
      TemplateName,
      MechanismSelector,
      tyc
    },
    data () {
      var that = this
      return {
        mechanismData: {
          callback (value) {
            that.mech = value
            that.selectChange(value)
          }
        },
        missionNames: '',
        missionList: '',
        pageTag: 'missionHisListPage',
        mechs: [],
        tqobj: '',
        taskType: '',
        name: '',
        row: this.$gRow,
        total: 0,
        dialogFormVisible: 0,
        tableData: [],
        loading: 0,
        editData: '',
        userId: '',
        missionName: '',
        mech: '',
        gBase: [

        ],
        gSub: [],
       
        selectedMissionType: ""
      }
    },
    computed: {
      index () {
        return this.$getWPage(this.pageTag)
      }
    },
    methods: {
      
      viewDetail (row) {
        // /mission-history/detail
        this.$setWObj('missionInfo', row)
        //this.$router.push({name: this.$t('menu.taskManageSub.detailHis')})
        this.$router.push({path: '/mission-history/detail'})
      },
      selectChange (vl) {
        this.mech = vl
        this.getList()
      },
      query () {
        console.log("selected type is " + this.missionName)
        this.getList()
      },
      cellClick (row,ev,col) {
        if (col.label && col.label === this.$t('app_operate')) {
          return
        }
        this.viewDetail(row)
        //console.log(row)
        //this.$setWObj('missionInfo', row)
        //this.$router.push({name: this.$t('menu.taskManageSub.detail')})
      },
      edit (row) {
        this.editData = row
        this.dialogFormVisible = 1
      },
      del (row) {
        this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', () => {
          // sure
          // console.log(row)
          var id = row.appClassifyId
          this.loading = 1
          this.$delAppType(id, (res) => {
            // this.delDeviceNo = 0
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        })
        // console.log(row)
      },
      pageSelect (index) {
        this.$setWPage(this.pageTag, index)
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      open () {
        if (this.editData) {
          // console.log(this.editData)
          this.name = this.editData.appClassifyName
        }
      },
      close () {
        // this.loading =0
        this.editData = ''
        this.name = ''
      },
      showInput () {
        this.dialogFormVisible = 1
      },
      newData () {
        var vl = this.name
        if (vl) {
          this.loading = 1
          this.$addAppType(vl, (res) => {
            this.loading = 0
            // console.log(res)
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          this.dialogFormVisible = 0
        } else {
          this.$message.error(this.$t('app_inputAName'))
        }
      },
      editRqs () {
        var vl = this.name
        if (vl) {
          this.loading = 1
          this.$editAppType(this.editData.appClassifyId, vl, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          this.dialogFormVisible = 0
        } else {
          this.$message.error(this.$t('app_inputAName'))
        }
      },
      sure () {
        if (this.editData) {
          // edit
          this.editRqs()
        } else {
          // new
          this.newData()
        }
      },
      getList () {

        this.loading = 1
        var mId = this.mech? this.mech : ''
        var type = this.taskType? this.taskType : ''
        var mName = (this.missionName != "0") ? this.missionName : ''
        var page = this.$getWPage(this.pageTag)
        page = page? page : 1
        this.$pushHis(page, this.$gRow, type, mName, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.status === 200) {
            console.log('data', res.data)
            this.tableData = res.data
            this.total = res.total
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
      }
    },
    mounted () {
//      this.$getChannelList(999, 1, (res) => {
//        if (res.status === 200) {
//          console.log(res)
//          this.mechs = res.data
//        } else {
//          this.$message.error(res.message)
//        }
//      }, () => {
//        this.$message.error(this.$t('app_rqsError'))
//      })

    
      var _this = this
      this.tqobj = {
        keys: ['taskType','taskTypeArr'],
        callback: (data) => {
          _this.missionNames=data[0]
          _this.missionList=data[1]
        }
      }

      var user = localStorage['userId']
      this.userId = user
      this.getList()
    }
  }
</script>



// WEBPACK FOOTER //
// Hislist.vue?bb425a62